import {FC, useMemo} from "react";
import {DisplayDesignItem} from "../../api/response/DisplayDesign";
import {Link, ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import {Link as RouterLink} from "react-router-dom"

type Props = {
  displayDesign: DisplayDesignItem
  selected: boolean
}

export const OwnedDesignItem: FC<Props> = ({displayDesign,selected}) => {
  const url = useMemo(() => {
    return `./display_design?id=${displayDesign.id}`
  }, [displayDesign])

  return <Link component={RouterLink} to={url}>
    <MenuItem selected={selected}>
      <ListItemIcon>
        <DesktopWindowsIcon/>
      </ListItemIcon>
      <ListItemText>{displayDesign.name}</ListItemText>
    </MenuItem>
  </Link>
}